<template>
  <div id="vipyong">
  
    <div class="private-ding" @click="showTan">
      <div class="private-ding-name">私人定制客服</div>
      <div class="private-ding-num">10000</div>
    </div>
    <div class="private-desc">登录聊天号，联系10000私人定制客服</div>
    <div class="app-name-div">
      <img src="../../assets/img/app-info-name@2x.png" alt />
      <div class="app-ba-content">限时福利</div>
    </div>
    <div class="fuli">
      <div class="fuli-content">
        定制安卓/苹果版，赠送永久会员
        <br />定制苹果版，＋1元赠送安卓版
      </div>
      <div class="fuli-app-list">
        <div class="fuli-app fuli-left">
          <img src="../../assets/img/android-logo@2x.png" alt />
          <br />
          <span>
            安卓版定制费
            <br />6999元
          </span>
        </div>
        <div class="fuli-app fuli-right">
          <img src="../../assets/img/ios-log@2x.png" alt />
          <br />
          <span>
            苹果版定制费
            <br />7999元
          </span>
        </div>
      </div>
    </div>
    <div class="app-name-div">
      <img src="../../assets/img/app-info-name@2x.png" alt />
      <div class="app-ba-content">温馨提示</div>
    </div>
    <div class="wenxin">
      <p>定制版本仅限本帐户使用，不能更换登陆手机<br/> 号。多手机号使用每个手机号需支付20%开通费。<br/>每个定制版本仅支持5个手机号使用。</p>
      <p>受限于苹果上架政策，苹果版本仅提供开发者版<br/>本，您每次更换苹果手机均需要按照安装指南重新<br/>安装</p>
      <p>由于需要私人定制，售出概不退款</p>
    </div>

    <div class="app-state">
      <img src="../../assets/img/vip-declare@2x.png" alt />
      <br />
      <div class="app-state-desc">
        <span>
          所有环节均采用金融级加密技术
          <br />极致的保护隐私，是我们共同的追求
        </span>
      </div>
    </div>


      <div class="tan" :class="{tanhide:codeshow}">
      <div class="tan-head">
        <img src="../../assets/img/vip-tan-top@2x.png" />
      </div>
      <div class="tan-page"  @click="showTan" >
          <span class="tan-page-s">私人定制客服</span><br>
          <span class="tan-page-sr">10000</span><br>
          <span class="tan-page-d">登录聊天号，联系10000客服</span>
      </div>
      <div class="tan-foot" @click="hideTan">
        <span>我知道了</span>
      </div>
    </div>
    <div class="tan-back" @touchmove.prevent :class="{tanhide:codeshow}"></div>
  

  </div>
</template>
<script>
export default {
  name: "vipyong",
  data() {
    return {
      msg: "注册协议",
      codeshow: true,
    };
  },
  methods:{
    hideTan:function(){
      this.codeshow=true;
    },
    showTan:function(){
      this.codeshow=false;
    }
  },
  
};
</script>
<style  scoped>
#vipyong {
  width: 100%;
  height: auto;
  margin: 0 0 0 0;
}


.private-ding {
  width: 692px;
  height: 152px;
  background: url("../../assets/img/vip-yong-private@2x.png");
  margin: 0 auto 26px;
  background-size: 100% 100%;
}

.private-ding-name {
  height: 152px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  float: left;
  line-height: 152px;
  margin-left: 50px;
}
.private-ding-name::before {
  background-image: url("../../assets/img/lianxi@2x.png");
  content: "";
  display: inline-block;
  width: 36px;
  height: 36px;
  margin-right: 2px;
  vertical-align: middle;
  background-size: 100%;
  margin: 0px 20px 0px 0px;
}

.private-ding-num {
  height: 152px;
  font-size: 100px;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  color: rgba(245, 195, 167, 1);
  float: left;
  line-height: 152px;
  margin-left: 12px;
}

.private-desc {
  height: 40px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 40px;
  margin: 0 auto 44px;
}
.fuli {
  width: 100%;
  height: 300px;
  margin: 0 auto 90px;
}

.fuli-content {
  height: 88px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #7d6b83;
  line-height: 40px;
  margin: 0 auto 20px;
}

.fuli-app-list {
  width: 518px;
  height: 170px;
  margin: 0 auto;
}

.fuli-app {
  width: 168px;
  height: 84px;
}
.fuli-app img {
  width: 76px;
  height: 76px;
}
.fuli-app span {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 40px;
}

.fuli-left {
  float: left;
}
.fuli-right {
  float: right;
}

.wenxin {
  width: 624px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 0.5);
  line-height: 40px;
  text-align: left;
  margin: 0px auto 26px 98px;
  counter-reset: num;
  word-break:break-all; 
  word-wrap:break-word;
}
.wenxin p {
  display: block;
   word-break:break-all; 
  word-wrap:break-word;
}
.wenxin p::before {
  counter-increment: num;
  content: counter(num);
  width: 42px;
  height: 42px;
  background: rgba(87, 95, 156, 1);
  border-radius: 50%;
  position: absolute;
  left: 44px;
  text-align: center;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 40px;
}

.app-name-div {
  width: 344px;
  height: 44px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 40px;
  margin: 0px auto 20px auto;
}

.app-name-div img {
  width: 100%;
  height: 1;
}

.app-ba-content {
  position: relative;
  top: -40px;
  font-size:32px;
  font-family:PingFangSC-Semibold,PingFang SC;
  font-weight:600;
  color:rgba(245,195,167,.8);
  line-height:44px;
}
.app-state {
  width: 100%;
  height: auto;
}

.app-state img {
  width: 130px;
  height: 10px;
}
.app-state-desc {
  width: 100%;
  height: 76px;
  margin: 26px auto 30px auto;
}

.app-state span {
  width: 384px;
  height: 76px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 0.5);
  line-height: 34px;
}



.tan {
  position: fixed;
  z-index: 9999;
  top: 428px;
  margin: 0 auto;
  position: fixed;
  width:540px;
  height:504px;
  background: rgba(255, 255, 255, 1);
  border-radius: 16px;
  margin: 0px 104px 0px 106px;
  z-index: 99990;
}

.tan-back {
  position: fixed;
  z-index: 9998;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
}

.tan-head {
  width: 100%;
  height: 140px;
}
.tan-head img {
  position: relative;
  width: 100%;
  height: 100%;
  float: right;
}
.tan-page {
  width: 100%;
  height: 214px;
  padding: 50px 0 0 0;
}

.tan-page-s {
  font-size:24px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:34px;
}

.tan-page-s::before{
  background-image: url("../../assets/img/vip-tan-lianxi@2x.png");
  content: "";
  display: inline-block;
  width: 36px;
  height: 36px;
  margin-right: 2px;
  vertical-align: middle;
  background-size: 100%;
  margin: 0px 20px 0px 0px;
}

.tan-page-sr {
  font-size:72px;
  font-family:DINAlternate-Bold,DINAlternate;
  font-weight:bold;
  color:rgba(223,186,117,1);
  line-height:84px;
  transform: scaleY(4);
  text-indent: 26px;

}
.tan-page-d{
  font-size:24px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:34px;
  line-height:110px;


}

.tan-foot {
  width: 100%;
  height: 100px;
  border-radius: 0px 0px 16px 16px;
  font-size:36px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(255,21,55,1);
  line-height:50px;
  border-top: 1px solid #E7E4E7;
 
}

.tan-foot span {
  font-size:36px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(255,21,55,1);
  line-height:100px;
}

.tanhide {
  display: none;
}

</style>


// WEBPACK FOOTER //
// src/components/common/personalBotton.vue